import React from 'react';
import ActionTextButton from "../Templates/ActionTextButton";

const SeeTextButton = ({className, onClick}) => {
  return (
    <ActionTextButton
      className={`${className}`}
      onClick={onClick}
      icon="eye"
      text="Ver"
    />
  );
};

export default SeeTextButton;
